module.exports = __webpack_public_path__ + "img/base-hierarquia-situacao.4bbeb71f.png";